var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0697 20.0002H0.505306C0.222335 20.0002 0 19.7779 0 19.4949V1.93048C0 1.64751 0.222335 1.42517 0.505306 1.42517H11.4199C11.8747 1.42517 12.097 1.9709 11.7736 2.2943L10.7832 3.26448C10.6923 3.35544 10.5609 3.40597 10.4295 3.40597H1.9808V18.0194H16.5942V9.5707C16.5942 9.43932 16.6448 9.30794 16.7357 9.21698L17.7059 8.22659C18.0192 7.90319 18.575 8.12552 18.575 8.5803V19.4949C18.575 19.7779 18.3527 20.0002 18.0697 20.0002Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96212 14.4621L5.427 11.4707C5.44721 11.3696 5.49775 11.2686 5.56849 11.1877L16.6145 0.151836C16.8166 -0.0502864 17.1299 -0.0502864 17.332 0.151836L19.8585 2.67836C20.0607 2.88049 20.0607 3.19378 19.8585 3.3959L8.81255 14.4318C8.74181 14.5025 8.64075 14.553 8.52958 14.5733L5.53817 15.0381C5.20467 15.0887 4.91159 14.7956 4.96212 14.4621ZM7.30674 12.2489L7.22589 12.7744L7.75141 12.6935L17.4129 3.03208L16.9682 2.58741L7.31685 12.2489H7.30674Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/IconEdit.38a9249ed03edd02e3ac68ec298ce142.svg";
export { ForwardRef as ReactComponent };